import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-footer-layout',
    template: `

    <div [ngClass]="{'modal-footer bg-light py-0':isModal}" [ngStyle]="getStyle()">
      <ng-content></ng-content>
    </div>
  `,
    standalone: false
})
export class FooterLayoutComponent {

  @Input() isModal = false;

  getStyle() {
    if (this.isModal) 
      return {'display': 'block'};
    return {};
  }
}

